import { render, staticRenderFns } from "./Semester.vue?vue&type=template&id=35b4d151&"
import script from "./Semester.vue?vue&type=script&lang=js&"
export * from "./Semester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports